import React, { useState } from "react";
import {
  Input,
  Select,
  DatePicker,
  AutoComplete,
  TimePicker,
  Button,
  Image,
  Upload,
  message,
} from "antd";
import "./floatInput.css";
import {
  CloseCircleFilled,
  DeleteOutlined,
  DownOutlined,
  UploadOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import CustomTimeRangePicker from "./CustomTimeRangePicker";
// import { colors } from "@material-ui/core";

// const { TextArea } = Input;

const FloatInput = (props) => {
  const { TextArea } = Input;
  const [focus, setFocus] = useState(false);
  // let { label, value, placeholder, type, required, selectOptions, maxLength, max, row, inputWidth } = props;
  let {
    label,
    value,
    placeholder,
    type,
    required,
    selectOptions,
    name,
    disabledDate,
    options,
    suffix,
    style,
    rows,
    maxLength,
    min,
    max,
    key,
    inputWidth,
    disabled,
    format,
    allowClear,
    optionFilterProp,
    onInputKeyDown,
    onKeyDown,
    onKeyUp,
    onFocus,
    textArea,
    autofocus,
    onSearch,
  } = props;

  if (!placeholder) placeholder = label;

  const isOccupied = focus || (value && value.length !== 0);
  const [previewImages, setPreviewImages] = useState([]);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const labelClass = "label as-label";
  const handleClear = () => {
    if (props.onChange) props.onChange("");
  };
  const requiredMark = required ? (
    <span className="text-danger" style={{ color: "red" }}>
      *
    </span>
  ) : null;

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));

      const previewPromises = imageFiles.map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => resolve(event.target.result);
          reader.readAsDataURL(file);
        });
      });

      Promise.all(previewPromises).then((previews) => {
        setPreviewImages(previews);
        props.onChange(imageFiles);
      });
    }
  };

  const handleDeleteImage = (index) => {
    setPreviewImages((prev) => prev.filter((_, i) => i !== index));
    const fileInput = document.getElementById(`file-upload-${props.name}`);
    if (fileInput) fileInput.value = "";

    props.onChange(null);
  };

  return (
    <div
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {type == "disnumber" && (
        <Input
          onChange={props.onChange}
          disabled={props.disabled}
          readOnly={true}
          suffix={suffix}
          type={type}
          max={props.max}
          value={value}
          min={props.min}
          maxLength={maxLength}
          placeholder={props.placeholder}
          style={{ width: inputWidth ? inputWidth : "" }}
        />
      )}
      {type == undefined && (
        <Input
          onChange={props.onChange}
          suffix={suffix}
          name={name}
          style={props.style}
          type={type}
          defaultValue={value}
          value={value}
          max={props.max}
          min={props.min}
          maxLength={maxLength}
          disabled={props.disabled}
          showCount={props.showCount}
          addonBefore={props.addonBefore}
          id={props.id}
          dir={props?.dir}
          placeholder={props?.placeholder}
          // style={{ width: inputWidth ? inputWidth : "" }}
        />
      )}
      {type == "text" && (
        <Input
          onChange={props.onChange}
          suffix={suffix}
          type={type}
          step={props.step}
          name={name}
          max={props.max}
          value={value}
          min={props.min}
          maxLength={maxLength}
          disabled={props.disabled}
          placeholder={props.placeholder}
          autoFocus={props.autofocus}
          allowClear
          style={{ width: inputWidth ? inputWidth : "" }}
          addonBefore={props.addonBefore}
        />
      )}

      {type == "email" && (
        <Input
          onChange={props.onChange}
          suffix={suffix}
          type={type}
          step={props.step}
          name={name}
          max={props.max}
          value={value}
          min={props.min}
          maxLength={maxLength}
          disabled={props.disabled}
          placeholder={props.placeholder}
          autoFocus={props.autofocus}
          style={{ width: inputWidth ? inputWidth : "" }}
          addonBefore={props.addonBefore}
        />
      )}
      {type === "number" && (
        <Input
          type="number"
          name={name}
          value={value}
          disabled={props.disabled}
          placeholder={props.placeholder}
          autoFocus={props.autofocus}
          style={{ width: inputWidth ? inputWidth : "" }}
          addonBefore={props.addonBefore}
          onChange={
            maxLength
              ? (e) => {
                  const val = e.target.value;
                  if (val.length > maxLength) {
                    props.onChange(val.slice(0, maxLength));
                  } else {
                    props.onChange(val);
                  }
                }
              : props.onChange
          }
          // onChange={(e) => {
          //   const val = e.target.value;
          //   if (maxLength && val.length > maxLength) {
          //     props.onChange(val.slice(0, maxLength));
          //   } else {
          //     props.onChange(val);
          //   }
          // }}

          // onChange={props.onChange}
        />
      )}

      {type == "password" && (
        <>
          <input
            type="text"
            name="fakeUsername"
            autoComplete="username"
            style={{ display: "none" }}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
          />
          <input
            type="password"
            name="fakePassword"
            autoComplete="new-password"
            style={{ display: "none" }}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
          />
          <Input
            type={passwordVisible ? "text" : "password"}
            onChange={(e) => props.onChange(e.currentTarget.value, name)}
            placeholder={props.placeholder}
            min={min}
            max={max}
            autoComplete="new-password"
            readOnly
            onFocus={(e) => e.target.removeAttribute("readonly")}
            suffix={
              <span
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {passwordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </span>
            }
            value={value}
            maxLength={maxLength}
          />
        </>
      )}
      {type == "select" && (
        <Select
          onChange={props.onChange}
          value={props.value}
          style={{ width: inputWidth ? inputWidth : "" }}
          dropdownStyle={props.dropdownStyle}
          disabled={props?.disabled}
          readOnly={props?.readOnly}
          loading={props?.isLoading}
          defaultValue={props.defaultValue}
          mode={props?.mode}
          filterOption={props?.filterOption}
          optionFilterProp={props?.optionFilterProp}
          size={props?.size}
          onSelect={props?.onSelect}
          allowClear={props?.allowClear}
          placeholder={props.placeholder}
        >
          {selectOptions}
        </Select>
      )}
      {type == "searchselect" && (
        <Select
          showSearch
          allowClear
          onSearch={(value) => {
            const max = props.maxLength || 10;
            if (value.length <= max) {
              props.onSearch?.(value);
            }
          }}
          onInputKeyDown={(e) => {
            const max = props.maxLength || 10;
            const inputValue = e.target.value || "";
            const isCharacterKey = e.key.length === 1;
            if (
              inputValue.length >= max &&
              isCharacterKey &&
              !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                e.key,
              )
            ) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
          onChange={props.onChange}
          value={props.value}
          style={{ width: inputWidth ? inputWidth : "" }}
          dropdownStyle={props.dropdownStyle}
          disabled={props?.disabled}
          readOnly={props?.readOnly}
          loading={props?.isLoading}
          defaultValue={props.defaultValue}
          mode={props?.mode}
          filterOption={props?.filterOption}
          optionFilterProp={props?.optionFilterProp}
          size={props?.size}
          options={props?.options}
          onSelect={props?.onSelect}
          // onInputKeyDown={props?.onInputKeyDown}
          onKeyDown={props?.onKeyDown}
          onKeyUp={props?.onKeyUp}
          onClear={props?.onClear}
          getPopupContainer={props?.getPopupContainer}
          removeIcon={props?.removeIcon}
          autoClearSearchValue={props?.autoClearSearchValue}
          placeholder={props.placeholder}
          ref={props?.ref}
          autoFocus={props.autofocus}
          clearIcon={
            <CloseCircleFilled
              style={{ fontSize: "14px", color: "rebeccapurple" }}
            />
          }
          type={type}
          name={name}
          max={props.max}
          min={props.min}
          maxLength={maxLength}
          addonBefore={props.addonBefore}
        >
          {selectOptions}
        </Select>
      )}
      {type === "selectMultiple" && (
        <div className="custom-select-wrapper">
          <Select
            showArrow
            showSearch
            allowClear
            suffixIcon={<DownOutlined style={{ fontSize: 12 }} />}
            mode="tags"
            onChange={(values) => {
              const filteredValues = Array.isArray(values)
                ? values.filter((v) => v && v.trim() !== "")
                : [];
              props.onChange(filteredValues);
            }}
            value={
              Array.isArray(props.value)
                ? props.value.filter((v) => v && v.trim() !== "")
                : typeof props.value === "string" && props.value.trim() !== ""
                  ? props.value.split(",").map((v) => v.trim())
                  : []
            }
            style={{ width: inputWidth || "100%" }}
            dropdownStyle={props.dropdownStyle}
            disabled={props?.disabled}
            readOnly={props?.readOnly}
            loading={props?.isLoading}
            defaultValue={props.defaultValue}
            filterOption={(input, option) => {
              if (!option?.value || option.value.trim() === "") return false;
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              );
            }}
            optionFilterProp="children"
            size={props?.size}
            options={props?.options}
            onSelect={props?.onSelect}
            onInputKeyDown={props?.onInputKeyDown}
            onKeyDown={props?.onKeyDown}
            onKeyUp={props?.onKeyUp}
            onClear={props?.onClear}
            getPopupContainer={props?.getPopupContainer}
            removeIcon={props?.removeIcon}
            autoClearSearchValue={props?.autoClearSearchValue}
            placeholder={props.placeholder}
            ref={props?.ref}
            autoFocus={props.autofocus}
            clearIcon={
              <CloseCircleFilled
                style={{ fontSize: "14px", color: "rebeccapurple" }}
              />
            }
          >
            {selectOptions}
          </Select>
        </div>
      )}

      {/* {type === "selectMultiple" && (
        <div className="custom-select-wrapper">
          <Select
            showArrow
            showSearch
            allowClear
            suffixIcon={<DownOutlined style={{ fontSize: 12 }} />}
            mode="tags"
            onChange={props.onChange}
            value={props.value}
            style={{
              width: inputWidth ? inputWidth : "100%",
            }}
            dropdownStyle={props.dropdownStyle}
            disabled={props?.disabled}
            readOnly={props?.readOnly}
            loading={props?.isLoading}
            defaultValue={props.defaultValue}
            filterOption={props?.filterOption}
            optionFilterProp={props?.optionFilterProp}
            size={props?.size}
            options={props?.options}
            onSelect={props?.onSelect}
            onInputKeyDown={props?.onInputKeyDown}
            onKeyDown={props?.onKeyDown}
            onKeyUp={props?.onKeyUp}
            onClear={props?.onClear}
            getPopupContainer={props?.getPopupContainer}
            removeIcon={props?.removeIcon}
            autoClearSearchValue={props?.autoClearSearchValue}
            placeholder={props.placeholder}
            ref={props?.ref}
            autoFocus={props.autofocus}
            clearIcon={
              <CloseCircleFilled
                style={{ fontSize: "14px", color: "rebeccapurple" }}
              />
            }
          >
            {selectOptions}
          </Select>
        </div>
      )} */}

      {type == "datePicker" && (
        <DatePicker
          onChange={(e) => props.onChange(e)}
          value={value}
          disabledDate={disabledDate}
          disabled={disabled}
          style={{ width: "100%" }}
          inputReadOnly={true}
          placeholder={""}
          defaultValue={props.defaultValue}
          format="DD-MM-YYYY"
        />
      )}

      {type == "yearPicker" && (
        <DatePicker
          onChange={(e) => props.onChange(e)}
          value={value}
          disabledDate={disabledDate}
          disabled={disabled}
          style={{ width: "100%" }}
          inputReadOnly={true}
          placeholder={""}
          defaultValue={props.defaultValue}
          picker="year"
        />
      )}
      {type == "timePicker" && (
        <TimePicker
          onChange={(e) => props.onChange(e)}
          value={value}
          disabledDate={disabledDate}
          disabled={disabled}
          use12Hours
          format={format}
          style={{ width: "100%" }}
          placeholder={""}
          inputReadOnly={true}
        />
      )}
      {type == "autoComplete" && (
        <AutoComplete
          dataSource={options}
          value={value}
          onChange={(value) => props.onChange(value)}
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={props.onSelect}
          maxLength={maxLength}
        />
      )}
      {type == "textArea" && (
        <TextArea
          value={value}
          name={name}
          rows={rows}
          maxLength={maxLength}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => props.onChange(e.target.value)}
          autoFocus={props.autofocus}
          style={{ width: inputWidth ? inputWidth : "" }}
          showCount
        />
      )}

      {type == "uploadButton" && (
        <Upload
          beforeUpload={(file) => {
            const isValidType = [
              "image/jpeg",
              "image/png",
              "image/jpg",
            ].includes(file.type);
            const isValidSize = file.size <= 1 * 1024 * 1024;

            if (!isValidType) {
              message.error(
                `Invalid format for ${file.name}. Only JPG, JPEG, PNG allowed.`,
              );
              return Upload.LIST_IGNORE;
            }

            if (!isValidSize) {
              message.error(
                `File ${file.name} too large. Maximum size is 1MB.`,
              );
              return Upload.LIST_IGNORE;
            }

            return false;
          }}
          listType="picture"
          className="upload-list-inline"
          defaultFileList={props.defaultFileList}
          // multiple={true}
          onChange={(info) => {
            props.onChange(info);
          }}
          disabled={props.disabled}
          accept={props.accept || ".jpg,.jpeg,.png"}
        >
          <Button icon={<UploadOutlined />} disabled={props.disabled}>
            Upload Image
          </Button>
        </Upload>
      )}

      {type == "timePickerRange" && (
        <CustomTimeRangePicker
          value={value}
          onChange={(val) => props.onChange(val)}
          disabled={disabled}
          placeholder={props.placeholder || ["Start Time", "End Time"]}
          label={label}
          required={required}
          error={props.error}
        />
      )}
      {/* {type == "uploadButton" && (
        <Upload
          beforeUpload={(file) => {
            const isValidType = [
              "image/jpeg",
              "image/png",
              "image/jpg",
              "application/pdf",
            ].includes(file.type);

            const isValidSize = file.size <= 1 * 1024 * 1024;

            if (!isValidType) {
              message.error(
                `Invalid format for ${file.name}. Only JPG, JPEG, PNG, PDF allowed.`
              );
              return Upload.LIST_IGNORE;
            }

            if (!isValidSize) {
              message.error(
                `File ${file.name} too large. Maximum size is 1MB.`
              );
              return Upload.LIST_IGNORE;
            }

            return false;
          }}
          listType="picture"
          className="upload-list-inline"
          defaultFileList={props.defaultFileList}
          onChange={(info) => {
            console.log({ info });
            props.onChange(info);
          }}
          disabled={props.disabled}
          accept=".jpg,.jpeg,.png,.pdf"
        >
          <Button icon={<UploadOutlined />} disabled={props.disabled}>
            Upload Image / PDF
          </Button>
        </Upload>
      )} */}

      <label className={labelClass} id={props.labelId} style={props.labelStyle}>
        {label} {requiredMark}
      </label>
    </div>
  );
};

export default FloatInput;
